import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { colors } from 'theme/colors';
import { ERouteLinks } from 'models/route';
import { EChipsVariants } from 'components/atoms/Chips';
import {
  StyledDashboardChips,
  StyledTableBox,
  StyledTableBoxItem,
} from 'pages/DashboardPage/styles';

const DashboardQuickPreview = () => (
  <StyledTableBox container>
    <Grid item container xs={12} sx={{ background: colors.blue100, padding: '20px 40px' }}>
      <Typography variant="h4" style={{ fontWeight: 'bold' }}>
        Quick preview of your applications
      </Typography>
    </Grid>
    <Grid item container xs={12} px="40px">
      <StyledTableBoxItem xs={12}>
        <Typography variant="body1">
          <Link to={ERouteLinks.Dashboard}>Certificate to possess a shotgun</Link>
        </Typography>
        <StyledDashboardChips text="in progress" variant={EChipsVariants.primary} />
      </StyledTableBoxItem>
      <StyledTableBoxItem xs={12}>
        <Typography variant="body1">
          <Link to={ERouteLinks.Dashboard}>Certificate to possess a firearm</Link>
        </Typography>
        <StyledDashboardChips text="Appointment Scheduled" variant={EChipsVariants.success} />
      </StyledTableBoxItem>
    </Grid>
  </StyledTableBox>
);

export { DashboardQuickPreview };
